import * as MuiInputAdornment from '@mui/material/InputAdornment'
import React from 'react'

export type InputAdornmentProps = MuiInputAdornment.InputAdornmentProps

export function InputAdornment({ children, ...props }: InputAdornmentProps) {
  return (
    <MuiInputAdornment.default {...props}>{children}</MuiInputAdornment.default>
  )
}
